module.exports = __webpack_public_path__ + "img/coulissante.aaace06.svg";